import React, { useState } from 'react';

import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import { useHistoricalPercentageChangeWidgetConfigSlice } from '../store';
import { HistoricalPercentageChangeWidgetGrid } from './grid/HistoricalPercentageChangeWidgetGrid';
import { HistoricalPercentageChangeWidgetChart } from './chart/HistoricalPercentageChangeWidgetChart';
import HistoricalPercentageChangeWidgetToolbar from './HistoricalPercentageChangeWidgetToolbar';

import './HistoricalPercentageChangeWidget.scss';
import SelectionStatus from 'portfolio/components/SelectionStatus.tsx';
import styleConstants from 'styles/variables.module.scss';
import { useWidgetContext } from 'widgets/WidgetContext.tsx';
import { GridApi } from '@instinet-analytics/semantic-ui-components';
import { histPriceVolStreamedDataSelectors } from 'widgets/historicalPercentageChange/store/data/streamSlice.ts';
import { initialHistPriceVolDataState } from 'widgets/historicalPercentageChange/store/data/HistoricalPercentageChangeDataState.ts';

const padding = 2 * parseInt(styleConstants.spaceAround);
const borderWidth = 2 * parseInt(styleConstants.layoutBorderWidth);

export default function HistoricalPercentageChangeWidget() {
    useWidgetStream();

    const { height } = useWidgetContext();
    const {
        config: { view },
    } = useHistoricalPercentageChangeWidgetConfigSlice();

    const { useWidgetStreamData } = histPriceVolStreamedDataSelectors;
    const streamData = useWidgetStreamData() ?? initialHistPriceVolDataState;

    const bodyHeight = height - borderWidth - padding;

    const [gridApi, setGridApi] = useState<GridApi | undefined>();

    // const data = useWidgetStreamData();
    const { hasValidSelection, portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();
    // const messages = useWidgetMessages();

    return (
        <div className="HistoricalPercentageChangeWidget">
            <HistoricalPercentageChangeWidgetToolbar gridApi={gridApi} />
            <SelectionStatus
                widgetName="Historical Percentage Change Widget"
                selectionRequirements={portfolioSelectionRequirements}
            />
            {hasValidSelection && (
                <>
                    {view === 'grid' && (
                        <HistoricalPercentageChangeWidgetGrid
                            onGridApiSet={setGridApi}
                            height={bodyHeight}
                            streamData={streamData}
                        />
                    )}
                    {view === 'chart' && (
                        <HistoricalPercentageChangeWidgetChart
                            streamData={streamData}
                        />
                    )}
                </>
            )}
        </div>
    );
}
